// Section 9 and 12: Well. 8 build points, 2 wood and 8 stone; water carriers yield 5.0 instead
// of 3.0; illness from fouled water 0.5x; can freeze in a Harsh winter (the decay phase freezes
// it at the end of Autumn with the land's chance, D-04; a frozen well gives nothing that Winter).
// Limit 1 per 30 people. Completing a queued well is a promised build (Section 16; production
// marks `building-complete.promised`). Constants: config.buildings.well.
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import { conditionFactor, buildingsOf } from '../../core/queries';
import { buildingEffectHook, combineModifiers, noDeltas } from '../../core/content-helpers';
import { defineBuilding } from '../../core/registry';

export function well(config: Config) {
  const c = config.buildings.well;

  return defineBuilding({
    id: 'well',
    label: 'Well',
    section: 'S9',
    buildPoints: c.buildPoints,
    materials: { wood: c.wood, stone: c.stone },
    material: 'stone',
    beds: 0,
    plots: 0,
    capacity: {},
    limit: { kind: 'per-people', people: c.peoplePerWell },
    modifierTargets: ['output', 'illnessRisk', 'buildingEffect'],
    modifierKeys: { output: ['water-carrier'] },
    modifiers: combineModifiers(
      buildingEffectHook('well', (_ctx, b) => (b.frozen ? 'frozen' : null)),
      (ctx, target) => {
        let working = 0;
        for (const b of buildingsOf(ctx.state, 'well'))
          if (!b.frozen) working = Math.max(working, conditionFactor(ctx.cfg, b));
        if (working <= 0) return [];
        if (target.kind === 'output' && target.jobId === 'water-carrier') {
          return [
            mod.add('building:well', config.jobs['water-carrier'].wellBonus * working, 'well'),
          ];
        }
        if (target.kind === 'illnessRisk') {
          return [
            mod.mul('building:well', 1 - (1 - c.fouledWaterIllness) * working, 'clean water'),
          ];
        }
        return [];
      },
    ),
    onComplete: noDeltas,
    onDamaged: noDeltas,
  });
}
